import { render } from "./Settings.vue?vue&type=template&id=5bcd5f6e&scoped=true&ts=true"
import script from "./Settings.vue?vue&type=script&lang=ts"
export * from "./Settings.vue?vue&type=script&lang=ts"

import "./Settings.vue?vue&type=style&index=0&id=5bcd5f6e&scoped=true&lang=css"
import "./Settings.vue?vue&type=style&index=1&id=5bcd5f6e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcd5f6e"]])

export default __exports__